import React from "react";

class NumberInput extends React.Component {
    constructor(props) {
        super(props);
    }

    preventNonNumericalInput(e) {
        if(e.target.value.match(/^[0]\d$/)){
            // Drop first val if given text starts with 0
            e.target.value = e.target.value.substring(1)
        }

        while (!e.target.value.match(/^[0-9]+[,]?([0-9]+)?$/)){
            if(!e.target.value){
                e.target.value = 0
            } else {
                e.target.value = e.target.value.slice(0, -1)
            }
        }
    }


    render() {
        return (
        <input {...this.props} type="text" onChange={(event)=> {
            this.preventNonNumericalInput(event)
            if(typeof this.props.onChange === "function"){
                this.props.onChange(event);
            }
        }} />
        )
    };
}

export default NumberInput;